import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IServerSettingsUnauthenticated } from '../../../settings/types/IServerSettingsUnauthenticated';

export interface IGetServerSettingsUnauthenticatedParams {
}

export interface IGetServerSettingsUnauthenticatedResult extends IResult, IServerSettingsUnauthenticated {
}

export class GetServerSettingsUnauthenticatedRequest
    extends Request<IGetServerSettingsUnauthenticatedParams, IGetServerSettingsUnauthenticatedResult> {
  constructor(params: IGetServerSettingsUnauthenticatedParams = {}) {
    super('getServerSettingsUnauthenticated', params);
  }
}
